// src/store/store.ts

import { configureStore } from '@reduxjs/toolkit';
import schemasReducer from '@center-pwa/reducers/schemasReducer';
import nodesReducer from '@center-pwa/reducers/nodesReducer';
import userProfileReducer from '@center-pwa/reducers/userProfileReducer';
import metaspacesReducer from '@center-pwa/reducers/metaspacesReducer';
import sphereReducer from '@center-pwa/reducers/sphereReducer';
import metaspaceEventsReducer from '@center-pwa/reducers/metaspaceEventsReducer';
import arcTemplatesReducer from '@center-pwa/reducers/arcTemplatesReducer';
import contextsReducer from '@center-pwa/reducers/contextsReducer';
import notificationsReducer from '@center-pwa/reducers/notificationsReducer';
import activeContextReducer from '@center-pwa/reducers/activeContextReducer';
import schemaTypesReducer from '@center-pwa/reducers/schemaTypesReducer';
import { sphereInfoAPI } from './sphereInfoAPI';
import { storeAnalyticsMiddleware } from './storeAnalyticsMiddleware';

const store = configureStore({
  reducer: {
    schemas: schemasReducer,
    schemaTypes: schemaTypesReducer,
    metaspaces: metaspacesReducer,
    nodes: nodesReducer,
    userProfile: userProfileReducer,
    sphere: sphereReducer,
    metaspaceEvents: metaspaceEventsReducer,
    arcTemplates: arcTemplatesReducer,
    contexts: contextsReducer,
    notifications: notificationsReducer,
    activeContext: activeContextReducer,
    [sphereInfoAPI.reducerPath]: sphereInfoAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(sphereInfoAPI.middleware)
      .concat(storeAnalyticsMiddleware),
});

// Infer the `RootState` and `AppDispatch` types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
